import { Button, Icon, Tooltip } from 'bold-ui'
import React from 'react'

import { downloadAcompanhamentoPreNatal } from '../impressao/DownloadAcompanhamentoPreNatal'

interface ImprimirPreNatalButtonProps {
  disabled?: boolean
  tooltipMessage?: string
  atendimentoId: ID
  prontuarioId: ID
  dataAtendimento: Instant
}

export function ImprimirPreNatalButton(props: ImprimirPreNatalButtonProps) {
  const { disabled, tooltipMessage, atendimentoId, prontuarioId, dataAtendimento } = props

  return (
    <Tooltip text={tooltipMessage ?? 'Imprimir'}>
      <Button
        onClick={() => downloadAcompanhamentoPreNatal({ atendimentoId, prontuarioId, dataAtendimento })}
        type='button'
        size='small'
        skin='ghost'
        disabled={disabled}
      >
        <Icon icon='printerOutline' />
      </Button>
    </Tooltip>
  )
}
